export default "__VITE_ASSET__Br_q_2pU__"